import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

type TableWrapperProps = { children?: ReactNode };

export const TableWrapper = styled.div<TableWrapperProps>`
  overflow: auto;
`;

type WrapperProps = { children?: ReactNode };

export const Wrapper = styled.div<WrapperProps>`
  padding: 45px 9px 0;
  padding-bottom: 0px;
`;

type CenteredProps = { children?: ReactNode; flexEnd?: boolean };

export const Centered = styled.div<CenteredProps>`
  display: flex;
  align-items: center;
  height: 100%;

  ${({ flexEnd }) =>
    flexEnd &&
    css`
      justify-content: flex-end;
    `}
`;
